"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiLockFill16 = {
    paths: [
        {
            path: 'M2,6 L2,4 C2,1.790861 3.79535615,0 6,0 C8.209139,0 10,1.79535615 10,4 L10,6 L10.9975267,6 C11.5511774,6 12,6.4556644 12,6.99539757 L12,15.0046024 C12,15.5543453 11.544239,16 10.9975267,16 L1.00247329,16 C0.448822582,16 0,15.5443356 0,15.0046024 L0,6.99539757 C0,6.44565467 0.455760956,6 1.00247329,6 L2,6 Z M5,10.0093689 L5,11.9906311 C5,12.5566468 5.44771525,13 6,13 C6.55613518,13 7,12.5480902 7,11.9906311 L7,10.0093689 C7,9.44335318 6.55228475,9 6,9 C5.44386482,9 5,9.45190985 5,10.0093689 Z M6,2 C4.8954305,2 4,2.8954305 4,4 L4,6 L8,6 L8,4 C8,2.8954305 7.1045695,2 6,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Lock',
    width: 12,
    height: 16,
};
var muiLockFill24 = {
    paths: [
        {
            path: 'M9,0 C12.3137085,0 15,2.6862915 15,6 L15,6 L15,9 L17.0066023,9 C17.5552407,9 18,9.44892021 18,10.007484 L18,10.007484 L18,22.992516 C18,23.5489341 17.5550537,24 17.0066023,24 L17.0066023,24 L0.993397683,24 C0.444759292,24 0,23.5510798 0,22.992516 L0,22.992516 L0,10.007484 C0,9.45106594 0.444946289,9 0.993397683,9 L0.993397683,9 L3,9 L3,6 C3,2.6862915 5.6862915,0 9,0 Z M9,13 L8.88266744,13.0066657 C8.38272018,13.0638981 8,13.4826715 8,13.990778 L8,13.990778 L8,18.009222 C8,18.5490248 8.44771525,19 9,19 L9,19 L9.11733256,18.9933343 C9.61727982,18.9361019 10,18.5173285 10,18.009222 L10,18.009222 L10,13.990778 C10,13.4509752 9.55228475,13 9,13 L9,13 Z M9,2 C6.790861,2 5,3.790861 5,6 L5,6 L5,9 L13,9 L13,6 C13,3.790861 11.209139,2 9,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Lock',
    width: 18,
    height: 24,
};
var muiLockFill = {
    base: muiLockFill16,
    smIcon: muiLockFill16,
    lgIcon: muiLockFill24,
};
exports.muiLockFill = muiLockFill;
//# sourceMappingURL=lockFill.js.map